import { Components } from "formiojs";

import editForm from "./Survey.form";

const SurveyComponent = Components.components.survey;

export default class CustomSurveyComponent extends (SurveyComponent as any) {
  public static editForm = editForm;

  static schema(...extend) {
    return SurveyComponent.schema({
      type: "survey",
      label: "Survey",
      key: "survey",
      questions: [],
      values: []
    });
  }

  static get builderInfo() {
    return {
      title: "Survey",
      group: "advanced",
      icon: "list",
      weight: 110,
      documentation: "/userguide/form-building/advanced-components#survey",
      schema: CustomSurveyComponent.schema()
    };
  }

  get defaultSchema() {
    return CustomSurveyComponent.schema();
  }
}

Components.addComponent("survey", CustomSurveyComponent);
